module.exports = function (dom) {
	dom = $(dom);
	var scrollTrigger = 100;
  var timer;
  function backToTop () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        dom.addClass('show');
      } else {
        dom.removeClass('show');
      }
    }, 500);
  };
  backToTop();
  $(window).on('scroll', function () {
      backToTop();
  });
  dom.on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
        scrollTop: 0
    }, 700);
  });
}


// WEBPACK FOOTER //
// ./src/components/top/index.js